export default function isTicket({ next }) {
  return next();
}
